module.exports = __webpack_public_path__ + "img/idx-title-service.2c38621.webp";